
export function wordParagraphId(state, data) {
    state.wordParagraphId = data
}



